module.exports = __webpack_public_path__ + "static/cashing-in-on-the-american-dream-09d9618026e9d304f2bea62431e50dff.jpg";